import Vue from 'vue'
import i18n from './i18n'
import request from '@/utils/request'
import ElementUI from 'element-ui'
import ZmTreeOrg from 'zm-tree-org'
import 'zm-tree-org/lib/zm-tree-org.css'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/permission'
import './utils/rem'
import '@/lib/css/flex.scss'
import '@/lib/css/style.scss'
import '@/lib/css/iconfont.css'
import VueClipboard from 'vue-clipboard2'
// import  '@/utils/mlmlogin/modal.js';
// import coco from '@/utils/mlmlogin/mlmlogin.js'
// let mlm = coco()
// mlm.init()
Vue.config.productionTip = false
Vue.prototype.$request = request
Vue.use(ZmTreeOrg)
Vue.use(ElementUI)
Vue.use(VueClipboard)
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
